import { readJson } from "../types"
import { csrfFetch } from "./csrf"

export async function mutationRequest(
  url: RequestInfo | URL,
  options: RequestInit,
  fallback: string,
  acceptedStatuses: number[] = []
) {
  const response = await csrfFetch(url, options).catch(() => {
    throw new Error(
      "Unable to reach the server. Check your connection and try again."
    )
  })
  if (response.ok || acceptedStatuses.includes(response.status)) return response

  const json = await readJson<unknown>(response).catch(() => ({
    data: undefined,
    error: undefined,
    errors: undefined,
  }))
  throw new Error(json.error || (json.errors || []).join(", ") || fallback)
}
